export default __webpack_public_path__ + "static/media/Spinner.c7eeb568.svg";